import { parseDate } from '@progress/kendo-intl';
import { AnimatePresence } from 'framer-motion';

import {
  Response,
  Action,
  AssessmentState,
  Player
} from '../../types/assessment-state';
import { Competency } from './competency';
import { CommentAction } from './comment-action';
import { Assessment } from '../../types/assessment';
import { GetResourceValue } from '../../features/assessment/assessment-document';

interface ActionPlanItemProps {
  document: Assessment;
  state: AssessmentState;
  id: string;
  titleResId?: string;
  descriptionResId?: string;
  averageScore?: number | undefined;
  actions?: Action[];
  responses?: Response[];
  players?: Player[];
}

export const ActionPlanItem = ({
  document,
  state,
  actions = [],
  responses = [],
  players,
  ...props
}: ActionPlanItemProps) => {
  return (
    <Competency
      className={'mt-3'}
      title={GetResourceValue(document, props.titleResId ?? '')}
      description={GetResourceValue(document, props.descriptionResId ?? '')}
      rating={props.averageScore}>
      <AnimatePresence>
        {actions.map((res, index) => {
          const dueDate = parseDate(res.targetDate);
          const assignee = res.assignee
            ? state.players?.find((i) => i.code === res.assignee)
            : { name: 'Unassigned', code: undefined };
          return (
            <CommentAction
              key={index}
              votes={res.totalVotes}
              dueDate={dueDate}
              status={res.status}
              assignee={res.assignee ? assignee?.name : '--'}>
              <div className={'d-flex align-items-center'}>
                <div className={'flex-grow-1'}>{res.name}</div>
              </div>
            </CommentAction>
          );
        })}
      </AnimatePresence>
    </Competency>
  );
};
